module.exports = __webpack_public_path__ + "img/img.f8155520.png";